

//const player = new mm.Player();
//importScripts("https://cdn.jsdelivr.net/npm/@magenta/music@^1.23.0");
const worker = new Worker(new URL("./db.js", import.meta.url), { type: "module" });
const worker_media_player = new Worker("media_player.js");



//window.onload = init;
var context;    // Audio context
var buf;        // Audio buffer
let stream;



export let microphone_output_buffer = [0]/*[0]*///new SharedArrayBuffer(1024);
if (crossOriginIsolated) {
  //console.log("111111111111111111111111111");
  microphone_output_buffer = new SharedArrayBuffer(1024);
  //myWorker.postMessage(buffer);
} else {
  //console.log("22222222222222222222222");
  microphone_output_buffer = new ArrayBuffer(1024);
  //myWorker.postMessage(buffer);
}

export let sampleRate = 48000;//como nao sei se eh igual a todos os navegadores
        /*var webaudio_tooling_obj = function () {

            var audioContext = new AudioContext();

            console.log("audio is starting up ...");

            var BUFF_SIZE_RENDERER = 16384;

            var audioInput = null,
            microphone_stream = null,
            script_processor_node = null;

            if (!navigator.getUserMedia)
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia || navigator.msGetUserMedia;

            if (navigator.getUserMedia){

                navigator.getUserMedia({audio:true},
                    function(stream) {
                        start_microphone(stream);
                    },
                    function(e) {
                        alert('Error capturing audio.');
                    }
                    );

            } else { alert('getUserMedia not supported in this browser.'); }

            function process_microphone_buffer(event) {

                var i, N, inp, microphone_output_buffer;

                microphone_output_buffer = event.inputBuffer.getChannelData(0); // just mono - 1 channel for now
                console.log("size = " + microphone_output_buffer.length);
                console.log("microphone_output_buffer" + microphone_output_buffer);
            }

            function start_microphone(stream){

                microphone_stream = audioContext.createMediaStreamSource(stream);
                script_processor_node = audioContext.createScriptProcessor(BUFF_SIZE_RENDERER, 1, 1);
                script_processor_node.onaudioprocess = process_microphone_buffer;

                microphone_stream.connect(script_processor_node);
            }

        }();*/ //  webaudio_tooling_obj = function()
 /*function process_microphone_buffer(event) {
    console.log("enviando para background!")
    worker.postMessage(["get_microphone_data", {event: event}]);

    //console.log("size = " + microphone_output_buffer.length);
    //console.log("microphone_output_buffer" + microphone_output_buffer);
}*/

export function microphoneAudioWorkletProcessor() {
  // Prompt the user to use their microphone.
    //var BUFF_SIZE_RENDERER = 16384;
    navigator.mediaDevices.getUserMedia({
        audio: {
            echoCancellation: false,
            autoGainControl: false,
            noiseSuppression: false,
            latency: 0
        }
    }).then((stream) => {
        const context = new AudioContext();
        const source = context.createMediaStreamSource(stream);/*
        const script_processor_node = context.createScriptProcessor(BUFF_SIZE_RENDERER, 1, 1);
        source.connect(script_processor_node);*/
        // Load and execute the module script.
        context.audioWorklet.addModule("processor.js").then(() => {
            const processor = new AudioWorkletNode(context, "processor");

            processor.port.onmessage = (event) => {
                microphone_output_buffer = event.data.value;
                sampleRate = event.data.sampleRate;

               // console.log('Received data from processor:', event.data.value.length);
                //console.log('event.data.value Type = ', event.data.value);
                //console.log('microphone_output_buffer Type = ', typeof microphone_output_buffer[0]);
            };
            source.connect(processor).connect(context.destination);

            console.log("Your microphone audio is being used.");
        });
        // Create an AudioWorkletNode. The name of the processor is the
        // one passed to registerProcessor() in the module script.

    })
}

export function requestMicrophone(){
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    //const analyser = audioContext.createAnalyser();//new
    navigator.mediaDevices.getUserMedia({ audio: true , sampleRate: 44100}).then((stream) => {
        /*analyser.fftSize = 16384;//2048;//new
        const bufferLength = analyser.fftSize;//new
        console.log(bufferLength);//new
        const dataArray = new Uint8Array(bufferLength);//new
        //const dataArray = new Float32Array(bufferLength);
        analyser.connect(audioContext.destination);//new
        analyser.getByteTimeDomainData(dataArray);//new
        console.log("dataArray = ", dataArray)
        microphone_output_buffer = dataArray*/
        function process_microphone_buffer(event) {
            var i, N, inp;
            /*if(globalThis.window === globalThis ){
                console.log("running on UI Thread! it should not!")
            }else{
                console.log("running on Worker Thread! :D")
            }*/
            //USAR WORKER PARA NAO USAR UI THREAD
            //console.log(event.inputBuffer.getChannelData(0));
            microphone_output_buffer = event.inputBuffer.getChannelData(0); // just mono - 1 channel for now
            //console.log("size = " + microphone_output_buffer.length);
            //console.log("microphone_output_buffer" + microphone_output_buffer);
        }

        const BUFF_SIZE_RENDERER = 1024//16384//1024*10;//tamjanela*10//16384;
        const source = audioContext.createMediaStreamSource(stream);
        /*
            COLOCAR DEPOIS,
          // Load and execute the module script.
          await context.audioWorklet.addModule("processor.js");
          // Create an AudioWorkletNode. The name of the processor is the
          // one passed to registerProcessor() in the module script.
          const processor = new AudioWorkletNode(context, "processor");

          source.connect(processor).connect(context.destination);

        */


        const script_processor_node = audioContext.createScriptProcessor(BUFF_SIZE_RENDERER, 1, 1);
        script_processor_node.onaudioprocess = process_microphone_buffer;

        source.connect(script_processor_node);



          // Load and execute the module script.
        /*await */
        console.log("Voce está usando o microfone.");
          //visualize(source);

          //analyser.getByteTimeDomainData(dataArray);

    }).catch((err) => {

          console.error("Erro ao acessar microfone:", err);

    });
}


//export function requestMicrophone(){
//    backMicrophone();
/*    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    navigator.mediaDevices.getUserMedia({ audio: true , sampleRate: 44100}).then((stream) => {

        const BUFF_SIZE_RENDERER = 16384;
        const source = audioContext.createMediaStreamSource(stream);
        const script_processor_node = audioContext.createScriptProcessor(BUFF_SIZE_RENDERER, 1, 1);
        script_processor_node.onaudioprocess = process_microphone_buffer;

        source.connect(script_processor_node);
          // Load and execute the module script.
        console.log("Your microphone audio is being used.");
    }).catch((err) => {
      console.error("Microphone access denied:", err);
    });*/
//}




function initAudio() {
    console.log("Your browser does not support any AudioContext and cannot play back this audio.");
    if (!window.AudioContext) {
        if (!window.webkitAudioContext) {
            console.log("Your browser does not support any AudioContext and cannot play back this audio.");
            return;
        } else{
            console.log("Your browser SUPPORTS AudioContext and can play back this audio.");
        }
            window.AudioContext = window.webkitAudioContext;
    }
    context = new AudioContext();
}

export function stopMedia(){
    stop()
}
export function playByteArray(byteArray) {
    console.log("vamos la");
    start(byteArray);
      /*let p = document.createElement("midi-player");
      p.setAttribute('src', 'https://cdn.jsdelivr.net/gh/cifkao/html-midi-player@2b12128/twinkle_twinkle.mid');
      document.body.appendChild(p);
      player = new html-midi-player();
      player.noteSequence = byteArray;
      player.play();*/
    /*console.log("byteArray");
    console.log(byteArray);
    const player = new mm.Player();
    player.start(byteArray);
    */

    /*
    fetch('https://magenta.github.io/magenta-js/music/demos/melody.mid') // Replace with your MIDI file path
    .then(response => response.arrayBuffer())
    .then(data => {
      const midi = new mm.MIDI();
      const noteSequence = midi.toNoteSequence(data);

      const player = new mm.Player();
      player.start(noteSequence);
    })*/

//    worker_media_player.postMessage({sequence: byteArray});
    /*
    var i;
    var arrayBuffer = new ArrayBuffer(byteArray.length);
    var bufferView = new Uint8Array(arrayBuffer);
    for (i = 0; i < byteArray.length; i++) {
      bufferView[i] = byteArray[i];
    }

    context.decodeAudioData(arrayBuffer, function(buffer) {
        buf = buffer;
        play();
    });*/
}
worker_media_player.onmessage = (event) => {
    if(event.data.fyi){
        console.log(event.data.fyi);
    }else{
        const sample = event.data.sample;
        //Do something with this sample
    }
}

// Play the loaded file
function play() {
    // Create a source node from the buffer
    var source = context.createBufferSource();
    source.buffer = buf;
    // Connect to the final output node (the speakers)
    source.connect(context.destination);
    // Play immediately
    source.start(0);
}
/*
$insertar.addEventListener("click", () => {
  worker.postMessage(["insertar_persona", { nombre: $nombre.value, fechaNacimiento: $fechaNacimiento.value }]);
});
$obtener.addEventListener("click", () => {
  worker.postMessage(["obtener_personas"]);
});*/
/*
$iniciarBaseDeDatos.onclick = () => {
  worker.postMessage(["iniciar"]);
}
*/
//formado funciona, mas aparece um erro, e.g: "exports.consulta"
export function consulta(){
    worker.postMessage(["get_songs"]);
    //return "era para vir do DB, mas ainda nao estou conseguindo"
}

export function consultaVariaveis(){
    worker.postMessage(["get_variables"]);
}

export function insertSong(name, lyric, notes, durations, legato, vibrato, author, exercise_part,
                                         standard_bpm, number_repetition, tone_variation_per_repetition, time_beats,
                                          time_beats_type, time, songScore){
    //debugger;//breakpoint
    //console.log("BEFORE insert_song name = " + name);
    worker.postMessage(["insert_song", { name: name, lyric: lyric, notes: notes, durations: durations, legato: legato, vibrato: vibrato, author: author, exercise_part: exercise_part,
      standard_bpm: standard_bpm, number_repetition: number_repetition, tone_variation_per_repetition: tone_variation_per_repetition, time_beats: time_beats,
       time_beats_type: time_beats_type, time: time, songScore: songScore }]);
}

export function insertVariables(/* bpm, tom, metronome, min_tom, max_tom, user_type, propaganda*/){
//0,0,1,6,23,"",0
    worker.postMessage(["insert_geral", { bpm: 0, tom: 0, metronome: 1, min_tom: 24/*30.6*/, max_tom: 40/*23*/, user_type: "", propaganda: 0 }]);
}

export function resetVariables(/* bpm, tom, metronome, min_tom, max_tom, user_type, propaganda*/){
//0,0,1,6,23,"",0
    worker.postMessage(["reset_geral", { bpm: 0, tom: 0, metronome: 1, min_tom: 24/*30.6*/, max_tom: 40/*23*/, user_type: "", propaganda: 0 }]);
}

export function update_metronome(metronome){
    worker.postMessage(["update_metronome", { metronome: metronome }]);
}

export function update_min_max_tone(min, max){
    worker.postMessage(["update_min_max_tone", { min: min, max: max }]);
}

export function new_pitch(newPitch){
    worker.postMessage(["new_pitch", { newPitch: newPitch}]);
}

export function new_bpm(newBPM){
    worker.postMessage(["new_bpm", { newBPM: newBPM}]);
}

export function update_with_metronome(value){
    worker.postMessage(["update_with_metronome", { value: value}]);
}

export function update_with_headphone(value){
    worker.postMessage(["update_with_headphone", { value: value}]);
}

export function update_song_score(id, score, epoch){
    worker.postMessage(["update_song_score", { score: score, epoch: epoch, id: id}]);
}

export function delete_song_name(name){
    worker.postMessage(["delete_song", {name: name}])
}

export function startDB() {
    //initAudio()
    worker.postMessage(["iniciar"]);
}

//CONSULTAS AO BANCO DE DADOS
//@Query("Select songScore from tbl_songs_novas where exercise_part = 1 or exercise_part = 2 or exercise_part = 3")
export let allSongs = "";
//-1000 = No defined...
export let changeBpm = 0;
export let changePitch= 0;
export let metronome = 1;
export let minPitch = null;
export let maxPitch =  null;
export let withHeadPhone= 0;
export let withMetronome= 0;
export let db_created = false;

worker.onmessage = evento => {
  const accion = evento.data[0];
  const argumentos = evento.data[1];
  switch (accion) {
    case "iniciado":
      //[$nombre, $fechaNacimiento, $insertar, $obtener].forEach(elemento => elemento.disabled = false);
      //db_created = true;
      break;
    case "song_inserted":
      //console.log({ argumentos });
      break;
    case "songs_got":
      const songs = argumentos;
      allSongs = JSON.stringify(songs);
      for (const song of songs) {
        //console.log({song});
        //console.log(JSON.stringify(song));
        //person = JSON.stringify(song);
        return JSON.stringify(song);
      }
      //console.log({songs});
      break;
    case "variables_got":
      changeBpm = argumentos[0].changeBpm;
      changePitch = argumentos[0].changePitch;
      metronome = argumentos[0].metronome;
      minPitch = argumentos[0].minPitch;
      maxPitch = argumentos[0].maxPitch;
      withHeadPhone = argumentos[0].withHeadPhone;
      withMetronome = argumentos[0].withMetronome;

      break;
    case "variables_inserted":
      db_created = true;
      break;
      //changeBpm, changePitch, metronome, minPitch, maxPitch, withHeadPhone, withMetronome
      //return {personas};//nobody receives it...
      /*$contenedorPersonas.innerHTML = "";
      for (const persona of personas) {
        $contenedorPersonas.innerHTML += `<strong>${persona.nombre}</strong> ${persona.fechaNacimiento}<br>`;
      }*/
      //break;
  }
}

